// @flow
import Enum from 'common/enums/Enum';

export const TeamStatusEnum = new Enum({
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
});

export const TeamEnum = new Enum({
    NoTeam: 'NO_TEAM'
});
